import Vue from 'vue'
import Router from 'vue-router'
import { loadLanguage } from '@/configs/language'
import Country from '@/views/Country'
import Login from '@/views/Login'
import beforeLogin from '@/views/beforeLogin'
import inputAccount from '@/views/inputAccount'
import Register from '@/views/Register'
import Home from '@/views/Home'
import Withdrawal from '@/views/Withdrawal'
import Success from '@/views/Success'
import MyLinkedAccount from '@/views/MyLinkedAccount'
import BasicLevel from '@/views/BasicLevel'
import SemiVerified from '@/views/SemiVerified'
import FullyVerified from '@/views/FullyVerified'
import EditBasicLevel from '@/views/EditBasicLevel.vue'
import BindBankAccount from '@/views/BindBankAccount'
import BindThirdPartyPayAccount from '@/views/BindThirdPartyPayAccount'
import BindNewPayPal from '@/views/BindNewPayPal'
import BindNewIMPS from '@/views/BindNewIMPS.vue'
import TransactionDetail from '@/views/TransactionDetail'
import Authorize from '@/views/Authorize'
import Protocol from '@/views/Protocol'
import Transfer from '@/views/Transfer'
import EditBankAccount from '@/views/EditBankAccount'
import EditThirdPartyPayAccount from '@/views/EditThirdPartyPayAccount'
import DocumentDetails from '@/views/DocumentDetails'
import Signing from '@/views/Signing'
import SigningPayroll from '@/views/SigningPayroll'
import Message from '@/views/Message'
import EditBasicUserInfo from '@/views/EditBasicUserInfo'
import CheckUserInfo from '@/views/checkUserInfo'
import EditNewIMPS from '@/views/EditNewIMPS.vue'
import QuickLoginAuth from '@/views/QuickLoginAuth.vue'
import Recharge from '@/views/Recharge.vue'
import TransactionRecord from '@/views/TransactionRecord.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.ROUTER_BASE,
  routes: [
    {
      path: '/',
      name: 'Home',
      meta: { keepAlive: true },
      component: Home
    },
    {
      path: '/protocol',
      name: 'Protocol',
      meta: { keepAlive: false },
      component: Protocol
    },
    {
      path: '/before-login',
      name: 'beforeLogin',
      meta: { keepAlive: false },
      component: beforeLogin
    },
    {
      path: '/input-account',
      name: 'inputAccount',
      meta: { keepAlive: false },
      component: inputAccount
    },

    {
      path: '/login',
      name: 'Login',
      meta: { keepAlive: false },
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      meta: { keepAlive: false },
      component: Register
    },
    {
      path: '/account/authorize',
      name: 'Authorize',
      meta: { keepAlive: false },
      component: Authorize
    },
    {
      path: '/account/quickLogin/authorize',
      name: 'QuickLoginAuth',
      meta: { keepAlive: false },
      component: QuickLoginAuth
    },
    {
      path: '/countries',
      name: 'Country',
      meta: { keepAlive: false },
      component: Country
    },
    {
      path: '/withdrawal',
      name: 'Withdrawal',
      meta: { keepAlive: false },
      component: Withdrawal
    },
    {
      path: '/withdrawal/result',
      name: 'WithdrawalResult',
      meta: { keepAlive: false },
      component: Success
    },
    {
      path: '/account/my-linked-account',
      name: 'MyLinkedAccount',
      meta: { keepAlive: false },
      component: MyLinkedAccount
    },
    {
      path: '/account/my-linked-account/bind-bank-account',
      name: 'BindBankAccount',
      meta: { keepAlive: false },
      component: BindBankAccount
    },
    {
      path: '/account/my-linked-account/bind-gcash-account',
      name: 'BindGcashAccount',
      meta: { keepAlive: false },
      component: BindThirdPartyPayAccount
    },
    {
      path: '/account/my-linked-account/bind-go-pay-account',
      name: 'BindGoPayAccount',
      meta: { keepAlive: false },
      component: BindThirdPartyPayAccount
    },
    {
      path: '/account/my-linked-account/bind-ovo-account',
      name: 'BindOVOAccount',
      meta: { keepAlive: false },
      component: BindThirdPartyPayAccount
    },
    {
      path: '/account/my-linked-account/bind-dana-account',
      name: 'BindDANAAccount',
      meta: { keepAlive: false },
      component: BindThirdPartyPayAccount
    },
    {
      path: '/account/my-linked-account/bind-paypal-account',
      name: 'BindPayPalAccount',
      meta: { keepAlive: false },
      component: BindThirdPartyPayAccount
    },
    {
      path: '/account/my-linked-account/bind-new-paypal',
      name: 'BindNewPayPal',
      meta: { keepAlive: false },
      component: BindNewPayPal
    },
    {
      path: '/account/my-linked-account/bind-payout-paypal',
      name: 'BindPayoutPayPal',
      meta: { keepAlive: false },
      component: BindNewPayPal
    },
    {
      path: '/account/my-linked-account/bind-new-imps',
      name: 'BindNewIMPS',
      meta: { keepAlive: false },
      component: BindNewIMPS
    },
    {
      path: '/account/my-linked-account/bind-epay-account',
      name: 'BindEPayAccount',
      meta: { keepAlive: false },
      component: BindThirdPartyPayAccount
    },
    {
      path: '/account/my-linked-account/bind-usdt-account',
      name: 'BindUSDTAccount',
      meta: { keepAlive: false },
      component: BindThirdPartyPayAccount
    },
    {
      path: '/account/my-linked-account/bind-ewallet-account',
      name: 'BindEWalletAccount',
      meta: { keepAlive: false },
      component: BindBankAccount
    },
    {
      path: '/account/my-linked-account/bind-qiwi-account',
      name: 'BindQiwiAccount',
      meta: { keepAlive: false },
      component: BindThirdPartyPayAccount
    },
    {
      path: '/account/my-linked-account/bind-upi-account',
      name: 'BindUPIAccount',
      meta: { keepAlive: false },
      component: BindThirdPartyPayAccount
    },
    {
      path: '/account/my-linked-account/bind-jazz-cash-account',
      name: 'BindJazzCash',
      meta: { keepAlive: false },
      component: BindThirdPartyPayAccount
    },
    {
      path: '/account/my-linked-account/bind-easy-paisa-account',
      name: 'BindEasyPaisa',
      meta: { keepAlive: false },
      component: BindThirdPartyPayAccount
    },
    {
      path: '/account/my-linked-account/edit-bank-account',
      name: 'EditBankAccount',
      meta: { keepAlive: false },
      component: EditBankAccount
    },
    {
      path: '/account/my-linked-account/edit-gcash-account',
      name: 'EditGcashAccount',
      meta: { keepAlive: false },
      component: EditThirdPartyPayAccount
    },
    {
      path: '/account/my-linked-account/edit-go-pay-account',
      name: 'EditGoPayAccount',
      meta: { keepAlive: false },
      component: EditThirdPartyPayAccount
    },
    {
      path: '/account/my-linked-account/edit-ovo-account',
      name: 'EditOVOAccount',
      meta: { keepAlive: false },
      component: EditThirdPartyPayAccount
    },
    {
      path: '/account/my-linked-account/edit-dana-account',
      name: 'EditDANAAccount',
      meta: { keepAlive: false },
      component: EditThirdPartyPayAccount
    },
    {
      path: '/account/my-linked-account/edit-paypal-account',
      name: 'EditPayPalAccount',
      meta: { keepAlive: false },
      component: EditThirdPartyPayAccount
    },
    {
      path: '/account/my-linked-account/edit-epay-account',
      name: 'EditEPayAccount',
      meta: { keepAlive: false },
      component: EditThirdPartyPayAccount
    },
    {
      path: '/account/my-linked-account/edit-new-paypal-account',
      name: 'EditNewPayPalAccount',
      meta: { keepAlive: false },
      component: EditThirdPartyPayAccount
    },
    {
      path: '/account/my-linked-account/edit-usdt-account',
      name: 'EditUSDTAccount',
      meta: { keepAlive: false },
      component: EditThirdPartyPayAccount
    },
    {
      path: '/account/my-linked-account/edit-ewallet-account',
      name: 'EditEWalletAccount',
      meta: { keepAlive: false },
      component: EditBankAccount
    },
    {
      path: '/account/my-linked-account/edit-qiwi-account',
      name: 'EditQiwiAccount',
      meta: { keepAlive: false },
      component: EditThirdPartyPayAccount
    },
    {
      path: '/account/my-linked-account/edit-new-imps',
      name: 'EditNewIMPS',
      meta: { keepAlive: false },
      component: EditNewIMPS
    },
    {
      path: '/account/my-linked-account/edit-upi-account',
      name: 'EditUPIAccount',
      meta: { keepAlive: false },
      component: EditThirdPartyPayAccount
    },
    {
      path: '/account/my-linked-account/edit-jazz-cash-account',
      name: 'EditJazzCash',
      meta: { keepAlive: false },
      component: EditThirdPartyPayAccount
    },
    {
      path: '/account/my-linked-account/edit-easy-paisa-account',
      name: 'EditEasyPaisa',
      meta: { keepAlive: false },
      component: EditThirdPartyPayAccount
    },
    {
      path: '/account/my-linked-account/edit-payout-paypal-account',
      name: 'EditPayoutPayPalAccount',
      meta: { keepAlive: false },
      component: EditThirdPartyPayAccount
    },
    {
      path: '/basic-level',
      name: 'BasicLevel',
      meta: { keepAlive: false },
      component: BasicLevel
    },
    {
      path: '/semi-verified',
      name: 'SemiVerified',
      meta: { keepAlive: false },
      component: SemiVerified
    },
    {
      path: '/fully-verified',
      name: 'FullyVerified',
      meta: { keepAlive: false },
      component: FullyVerified
    },
    {
      path: '/edit-basic-level',
      name: 'EditBasicLevel',
      meta: { keepAlive: false },
      component: EditBasicLevel
    },
    {
      path: '/trans/detail',
      name: 'TransactionDetail',
      meta: { keepAlive: false },
      component: TransactionDetail
    },
    {
      path: '/document-details',
      name: 'DocumentDetails',
      meta: { keepAlive: false },
      component: DocumentDetails
    },
    {
      path: '/signing',
      name: 'Signing',
      meta: { keepAlive: false },
      component: Signing
    },
    {
      path: '/signing-payroll',
      name: 'SigningPayroll',
      meta: { keepAlive: false },
      component: SigningPayroll
    },
    {
      path: '/message',
      name: 'Message',
      meta: { keepAlive: false },
      component: Message
    },
    {
      path: '/transfer',
      name: 'Transfer',
      meta: { keepAlive: false },
      component: Transfer
    },
    {
      path: '/bankcard/result',
      name: 'bankcardResult',
      meta: { keepAlive: false },
      component: Success
    },
    {
      path: '/edit/userInfo',
      name: 'EditBasicUserInfo',
      meta: { keepAlive: false },
      component: EditBasicUserInfo
    },
    {
      path: '/check-user-info',
      name: 'CheckUserInfo',
      meta: { keepAlive: false },
      component: CheckUserInfo
    },
    {
      path: '/recharge',
      name: 'Recharge',
      meta: { keepAlive: false },
      component: Recharge
    },
    {
      path: '/transaction-record',
      name: 'TransactionRecord',
      meta: { keepAlive: false },
      component: TransactionRecord
    },
    { path: '*', name: 'NoFoundPage', meta: { keepAlive: true }, component: Home }
  ]
})

// 路由前置守卫
router.beforeEach((to, _from, next) => {
  const { query } = to
  const { language } = query
  // 根据语言设置加载语言包
  // 优先级 routerQuery > localStorage > navigator.language > default('en')
  let lang = localStorage.getItem('language') || navigator.language || 'en'
  if (language) {
    // 通过query传入的语音可能是一个数组
    lang = language instanceof Array ? language[0] : language
  }
  loadLanguage(lang)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js